<script lang="ts">
    import * as Pagination from "../ui/pagination/index.js";
    import * as Select from "../ui/select/index.js";
    import { m } from "../../messages.svelte.js";

    interface Props {
        pageSizeOptions?: readonly number[];
        pageSize: number;
        pageNumber: number;
        totalCount: number;
        onPageSizeChange?: (size: number) => void;
        onPageChange?: (page: number) => void;
    }

    const {
        pageSizeOptions = [10, 25, 50, 100],
        pageSize,
        pageNumber,
        totalCount,
        onPageSizeChange,
        onPageChange,
    }: Props = $props();

    const totalPages = $derived(Math.ceil(totalCount / pageSize));
    const showingFrom = $derived(totalCount === 0 ? 0 : (pageNumber - 1) * pageSize + 1);
    const showingTo = $derived(Math.min(pageNumber * pageSize, totalCount));
</script>

<div class="bg-background flex items-center justify-between border-t px-4 py-2">
    <div class="text-muted-foreground flex shrink-0 items-center gap-2 text-xs">
        <span class="whitespace-nowrap">{m["workbench.rowsPerPage"]()}</span>
        <Select.Root
            type="single"
            value={String(pageSize)}
            onValueChange={v => {
                onPageSizeChange?.(Number(v));
            }}
        >
            <Select.Trigger class="h-7 w-[60px] text-xs">
                {pageSize}
            </Select.Trigger>
            <Select.Content>
                {#each pageSizeOptions as size (size)}
                    <Select.Item value={String(size)}>{size}</Select.Item>
                {/each}
            </Select.Content>
        </Select.Root>
        <span class="ml-4 whitespace-nowrap">
            {m["workbench.showingResults"]({
                from: showingFrom,
                to: showingTo,
                total: totalCount,
            })}
        </span>
    </div>
    {#if totalPages > 1}
        <Pagination.Root
            count={totalCount}
            perPage={pageSize}
            page={pageNumber}
            onPageChange={p => {
                onPageChange?.(p);
            }}
        >
            {#snippet children({ pages, currentPage })}
                <Pagination.Content>
                    <Pagination.Item>
                        <Pagination.PrevButton />
                    </Pagination.Item>
                    {#each pages as page (page.key)}
                        {#if page.type === "ellipsis"}
                            <Pagination.Item>
                                <Pagination.Ellipsis />
                            </Pagination.Item>
                        {:else}
                            <Pagination.Item>
                                <Pagination.Link {page} isActive={currentPage === page.value}>
                                    {page.value}
                                </Pagination.Link>
                            </Pagination.Item>
                        {/if}
                    {/each}
                    <Pagination.Item>
                        <Pagination.NextButton />
                    </Pagination.Item>
                </Pagination.Content>
            {/snippet}
        </Pagination.Root>
    {/if}
</div>
